import React from "react";
import Tx from "../../../../../types/naming";
import { EmptyDashboard } from "@modules/dashboards/empty/empty";
import { getEmptyTextBlock } from "@modules/dashboards/empty/common";

const getEmptySvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="319" viewBox="0 0 1240 319" fill="none">
            <rect x="360.172" width="619" height="32" rx="10" fill="#EAEAEB" />
            <rect x="360.172" y="48" width="546" height="32" rx="10" fill="#EAEAEB" />
            <rect x="360.172" y="96" width="327" height="32" rx="10" fill="#EAEAEB" />
            <rect x="360.172" y="144" width="719" height="32" rx="10" fill="#EAEAEB" />
            <rect x="360.172" y="192" width="416" height="32" rx="10" fill="#EAEAEB" />
            <rect x="360.172" y="240" width="201" height="32" rx="10" fill="#EAEAEB" />
            <circle cx="12.1719" cy="17" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="13" width="225" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="12.1719" cy="65" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="61" width="140" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="12.1719" cy="113" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="109" width="266" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="12.1719" cy="161" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="157" width="202" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="12.1719" cy="209" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="205" width="180" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="12.1719" cy="257" r="7" fill="#EAEAEB" />
            <rect x="28.1719" y="253" width="243" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="12" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="60" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="108" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="156" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="204" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1136.17" y="252" width="80" height="8" rx="2" fill="#EAEAEB" />
            <rect width="1240" height="318" transform="translate(0 1)" fill="url(#paint0_linear_6713_60539)" />
            <defs>
                <linearGradient
                    id="paint0_linear_6713_60539"
                    x1="620"
                    y1="-23.5548"
                    x2="620"
                    y2="288.361"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const Empty = () => {
    return <EmptyDashboard name={Tx.Culture} emptyTextBlock={getEmptyTextBlock()} content={getEmptySvg()} />;
};